<template>
    <v-container
        class="fill-height"
        fluid
        dark
        style="background-size: cover"
    >
   
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-col cols="12" class="text-center">
                    <img alt="Login" src="../../assets/images/fc-logo.png" style="width: 250px;">
                </v-col>
                <v-card class="elevation-12">
                    <v-card-text>
                        <v-col cols="12" class="text-center">Cambiar Contraseña </v-col>
                        <v-form ref="form_change_password">
                            <v-text-field
                                v-model="password"
                                label="Ingrese la nueva contraseña"
                                prepend-icon="mdi-lock"
                                type="text"
                                :rules=requiredRule
                            ></v-text-field>

                            <v-text-field
                                v-model="password2"
                                label="Repita la contraseña"
                                prepend-icon="mdi-lock"
                                type="text"
                                :rules=requiredRule
                            ></v-text-field>
                            
                        </v-form>
                    </v-card-text>
                    <v-spacer></v-spacer>
                    <v-col cols="12">
                        <v-btn 
                            color="primary" 
                            block
                            class="px-5"
                            @click="cambiarContrasena"
                            :loading=loadingBtn
                        >
                             Cambiar
                        </v-btn>
                    </v-col>
                    <v-row class="px-3">
                        <v-col cols="12" class="text-center">
                            <v-btn 
                                small 
                                text 
                                color="primary"
                                link
                                to="/login"
                            >
                              <v-icon>mdi-login</v-icon>   Regresar al inicio
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'

export default {
    name:'CambiarContrasenaComponent',
    data: () =>({
        show: false,
        password:'',
        password2:'',
        company:'',
        requiredRule:[
            v => !!v || 'El campo es requerido'
        ],
    }),
    computed:{
        ...mapState('master',['loadingBtn'])
    },
    methods:{

        ...mapMutations('master',[]),

        ...mapActions('access',['cambiarPassword']),
    
        cambiarContrasena(){
            
            /*if(!this.$refs.form_change_password.validate()) {
				return
			}*/
			 this.cambiarPassword({token:this.token,password:this.password})
            
            
        }
    },
     mounted(){
        document.title = "Cambiar  contraseña";
        this.token = this.$route.query.t;

        //verificar si el token es valido
    }
}
</script>

